(function(window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    var FORM_SELECTOR = '[data-jvz-form]';

    var applyBindings = function($root) {
        $root.find(FORM_SELECTOR).each(function (index, value) {
            var $form = $(value);

            $form.jvzSubmitBlocks = $form.jvzSubmitBlocks || {};

            window.JVZoo.Controls.PauseFormSubmission.subscribe(
                $form,
                function(args){
                    console.debug("Form Submission Paused. ", args.targetElement);
                    $form.jvzSubmitBlocks[args.targetElement] = true;
                },
                {}
            );

            window.JVZoo.Controls.AllowFormSubmission.subscribe(
                $form,
                function(args){
                    console.debug("Form Submission Allowed. ", args.targetElement);
                    delete $form.jvzSubmitBlocks[args.targetElement];
                },
                {}
            );

            $form.submit(function( event ) {
                if (!window.JVZoo.Common.IsEmptyObject($form.jvzSubmitBlocks)) {
                    alert("Please wait for all tasks to complete before submitting.");
                    event.preventDefault();
                }
            });
        });
    };

    $(document).ready(function() {
        applyBindings($(document));
    });

})(window, jQuery);